import React from 'react';
import { motion } from 'framer-motion';
export function ProductSection() {
  const items = [{
    title: 'Protocolo Principal Silencio TTPM™',
    desc: 'Una rutina guiada paso a paso para hacer por la noche antes de dormir.'
  }, {
    title: 'Audio de calma nocturna',
    desc: 'Una guía auditiva diseñada para acompañarte mientras bajas la activación mental.'
  }, {
    title: 'Técnica de emergencia para noches difíciles',
    desc: 'Para esos momentos donde el zumbido parece más intenso y necesitas recuperar control.'
  }, {
    title: 'Checklist de detonantes nocturnos',
    desc: 'Una lista simple para identificar hábitos que pueden empeorar tu percepción del ruido antes de dormir.'
  }, {
    title: 'Mini guía: Cómo dejar de medir el zumbido',
    desc: 'Una explicación práctica para evitar el patrón de revisar constantemente si el sonido sigue ahí.'
  }, {
    title: 'Acceso inmediato',
    desc: 'Puedes empezar hoy mismo, desde tu celular.'
  }];
  return <section className="py-16 md:py-24 px-5 md:px-8 bg-[#0B1224] border-y border-[#15203B]" data-id="element-243">
      <div className="max-w-4xl mx-auto" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-245">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-246">
            Lo que recibes hoy
          </h2>
          <div className="w-24 h-1 bg-[#F6C65B] mx-auto rounded-full" data-id="element-247"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-248">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-[#070B16] p-6 rounded-xl border border-[#15203B] flex gap-4 hover:border-[#F6C65B]/30 transition-colors" data-id="element-249">
              <div className="flex-shrink-0 w-10 h-10 bg-[#F6C65B]/10 rounded-full flex items-center justify-center border border-[#F6C65B]/30 mt-1" data-id="element-250">
                <span className="text-[#F6C65B] font-bold" data-id="element-251">✓</span>
              </div>
              <div data-id="element-252">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-253">
                  {item.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-254">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}